import { HotelReviewsList } from '../../components';
import { withLayout } from '../../Layout/Layout';
import React from 'react';
import Head from 'next/head';

export function Reviews() {
  return (
    <>
      <Head>
        <meta
          name="description"
          content={
            'Explore comprehensive hotel reviews on First-Class.com. Discover luxury accommodations, amenities, and travel experiences from around the world'
          }
        />
        <title>Hotel Reviews: Honest Assessments of Luxury Hotels</title>
      </Head>
      <HotelReviewsList type="default" listTitle="Hotels reviews" />
    </>
  );
}

export default withLayout(Reviews, true);
